module.exports = __webpack_public_path__ + "img/copy-link.897c29e.svg?v=1762502055057";